// services/clientes.js
import axiosInstance from './axiosInstance';

const CLIENTES_API_URL = '/clientes'; // Replace with your actual API endpoint

const clientesService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async export(idempresa) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/export.php?idempresa=${idempresa}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async unset(idempresa, codigo) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/unset.php?idempresa=${idempresa}&codigo=${codigo}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async import(formData) {
    try {
      const response = await axiosInstance.post(`${CLIENTES_API_URL}/import.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getById(idempresa, codigo) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/getById.php?idempresa=${idempresa}&codigo=${codigo}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async set(clienteData) {
    try {
      const response = await axiosInstance.post(`${CLIENTES_API_URL}/set.php`, clienteData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getStatistics(idempresa, codigo, startDate, endDate, nif) {
    try {
      const nifParam = nif ? `&nif=${nif}` : '';
      const response = await axiosInstance.get(`/statistics/customer/get.php?idempresa=${idempresa}&customer=${codigo}&startdate=${startDate}&enddate=${endDate}${nifParam}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getDescontos(idempresa, codigo) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/descontos/getById.php?idempresa=${idempresa}&cliente=${codigo}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getMatriculas(idempresa, codigo) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/matriculas/getById.php?idempresa=${idempresa}&cliente=${codigo}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getMembersAccess(idempresa, codigo) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/members/access/getById.php?idempresa=${idempresa}&codigo=${codigo}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getNifList(idempresa) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/nif/get.php?idempresa=${idempresa}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async setDesconto(descontoData) {
    try {
      const response = await axiosInstance.post(`${CLIENTES_API_URL}/descontos/set.php`, descontoData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async unsetDesconto(descontoData) {
    try {
      const response = await axiosInstance.post(`${CLIENTES_API_URL}/descontos/unset.php`, descontoData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getMatriculaById(idempresa, codigoMatricula) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/matriculas/getById.php?idempresa=${idempresa}&codigo=${codigoMatricula}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async getMatriculaByIdWithCliente(idempresa, cliente, codigoMatricula) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/matriculas/getById.php?idempresa=${idempresa}&cliente=${cliente}&codigo=${codigoMatricula}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async setMatricula(matriculaData) {
    try {
      const response = await axiosInstance.post(`${CLIENTES_API_URL}/matriculas/set.php`, matriculaData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async unsetMatricula(matriculaData) {
    try {
      const response = await axiosInstance.post(`${CLIENTES_API_URL}/matriculas/unset.php`, matriculaData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async generateMemberCard(idempresa, codigo) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/members/generate.php?idempresa=${idempresa}&codigo=${codigo}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async sendMemberCardEmail(emailData) {
    try {
      const response = await axiosInstance.post(`${CLIENTES_API_URL}/members/mail.php`, emailData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async sendMatriculaEmail(emailData) {
    try {
      const response = await axiosInstance.post(`${CLIENTES_API_URL}/matriculas/mail.php`, emailData);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async unsetService(idempresa, codigo, idservice) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/services/unset.php?idempresa=${idempresa}&codigo=${codigo}&idservice=${idservice}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  // Consumption methods - /api/clientes/consumption
  async getConsumption(idempresa, cliente, posto, startdate, enddate, pagamento) {
    try {
      const pagamentoParam = pagamento ? `&pagamento=${pagamento}` : '';
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/consumption/getById.php?idempresa=${idempresa}&cliente=${cliente}&posto=${posto}&startdate=${startdate}&enddate=${enddate}${pagamentoParam}`);
      return response.data !== "NOK" ? response.data.lines : [];
    } catch (error) {
      console.error('Erro ao obter consumo:', error);
      return [];
    }
  },

  // Members access methods
  async getMembersAccessList(idempresa, induty = false) {
    try {
      const indutyParam = induty ? '&induty=true' : '';
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/members/access/get.php?idempresa=${idempresa}${indutyParam}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter lista de acesso de membros:', error);
      return [];
    }
  },

  async setMemberOut(idempresa, codigo) {
    try {
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/members/out.php?idempresa=${idempresa}&codigo=${codigo}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao registar saída de membro:', error);
      throw error;
    }
  },

  // Members authorization methods
  async authorizeMember(token, idempresa, card, phone = null) {
    try {
      const cardParam = card ? `&card=${encodeURIComponent(card).toUpperCase()}` : '';
      const phoneParam = phone ? `&phone=${encodeURIComponent(phone)}` : '';
      const response = await axiosInstance.get(`${CLIENTES_API_URL}/members/authorize.php?token=${token}&idempresa=${idempresa}${cardParam}${phoneParam}`);
      
      // Return a response object that mimics fetch API for compatibility
      return {
        ok: true,
        json: async () => response.data
      };
    } catch (error) {
      console.error('Erro ao autorizar membro:', error);
      return {
        ok: false,
        json: async () => ({ status: 'ERROR', message: 'Erro na autenticação' })
      };
    }
  },
};

export default clientesService;